import { connect } from 'react-redux';
import {
  getTabKey,
  isAuthorizationDeletingEntity,
  isAuthorizationFetchingGroups,
  isAuthorizationFetchingUsers,
  isAuthorizationUpdatingGroup,
  isAuthorizationUpdatingUser,
} from '../../reducers/analyticsApp';
import { fetchGroups, fetchUsers, setTabKey } from '../../actions/authorization';
import AuthorizationView from '../../components/authorization/AuthorizationView';

const mapStateToProps = (state) => ({
  fetchingGroups: isAuthorizationFetchingGroups(state),
  updatingGroup: isAuthorizationUpdatingGroup(state),
  fetchingUsers: isAuthorizationFetchingUsers(state),
  updatingUser: isAuthorizationUpdatingUser(state),
  deleting: isAuthorizationDeletingEntity(state),
  tabKey: getTabKey(state),
});

export default connect(mapStateToProps, { fetchGroups, fetchUsers, setTabKey })(AuthorizationView);
